"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MuiButtonDownload = _interopRequireDefault(require("../MuiButtonDownload/MuiButtonDownload"));

var _MuiButtonHref = _interopRequireDefault(require("../MuiButtonHref/MuiButtonHref"));

var _MuiButtonRedirect = _interopRequireDefault(require("../MuiButtonRedirect/MuiButtonRedirect"));

var _MuiIconButtonDownload = _interopRequireDefault(require("../MuiIconButtonDownload/MuiIconButtonDownload"));

var _MuiIconButtonHref = _interopRequireDefault(require("../MuiIconButtonHref/MuiIconButtonHref"));

var _MuiIconButtonRedirect = _interopRequireDefault(require("../MuiIconButtonRedirect/MuiIconButtonRedirect"));

var _customProps = require("../../utils/customProps");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var GoogleConversions = function GoogleConversions(_ref) {
  var sendTo = _ref.sendTo,
      aWConversionID = _ref.aWConversionID,
      button = _ref.button;
  var components = {
    MuiButtonDownload: _MuiButtonDownload.default,
    MuiButtonHref: _MuiButtonHref.default,
    MuiButtonRedirect: _MuiButtonRedirect.default,
    MuiIconButtonDownload: _MuiIconButtonDownload.default,
    MuiIconButtonHref: _MuiIconButtonHref.default,
    MuiIconButtonRedirect: _MuiIconButtonRedirect.default
  };

  var conversionCall = function conversionCall() {
    window.aWConversionID = aWConversionID;

    var callback = function callback() {
      console.log('Conversion Call back called: ', sendTo);
    };

    window.gtag('event', 'conversion', {
      send_to: sendTo,
      event_callback: callback
    });
    window.aWConversionID = undefined;
    return false;
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/(0, _react.createElement)(components[button[0].component], _objectSpread(_objectSpread({}, button[0]), {}, {
    callback: conversionCall
  })));
};

var _default = GoogleConversions;
exports.default = _default;
GoogleConversions.propTypes = {
  sendTo: _propTypes.default.string.isRequired,
  aWConversionID: _propTypes.default.string.isRequired,
  button: function button(props, propName, componentName) {
    var validComponents = [_MuiButtonDownload.default, _MuiButtonHref.default, _MuiButtonRedirect.default, _MuiIconButtonDownload.default, _MuiIconButtonHref.default, _MuiIconButtonRedirect.default];
    return (0, _customProps.validComponentsRequired)(props, propName, componentName, validComponents, 1);
  }
};
GoogleConversions.defaultProps = {
  button: []
};